import React from 'react';

import Html from 'views/components/html';
import Header from 'views/components/header';
import HeroImage from 'views/components/hero-image';
import Body from 'views/components/body';
import Contents from 'views/components/contents';
import Footer from 'views/components/footer';
import { Message } from './index.styled';

const FourOFour = () => {
  return (
    <>
      <Html title="404" />
      <Header />
      <HeroImage>
        <Body>
          <Contents>
            <Message>
              404
            </Message>
          </Contents>
        </Body>
      </HeroImage>
      <Footer />
    </>
  );
};

export default FourOFour;
